const DatePickerDays = ({ month, year, selectedDate, onSelectDay }) => {
  const today = new Date();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfWeek = new Date(year, month, 1).getDay(); // 0=Sunday

  const days = [];

  // Offset cells for alignment
  for (let i = 0; i < firstDayOfWeek; i++) {
    days.push(<span key={`off-${i}`} className="dp-day dp-day--offset" />);
  }

  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    const dayOfWeek = (firstDayOfWeek + d - 1) % 7;
    const isToday =
      d === today.getDate() &&
      month === today.getMonth() &&
      year === today.getFullYear();
    const isSelected = selectedDate === dateStr;
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    days.push(
      <button
        key={d}
        type="button"
        className={[
          "dp-day",
          isToday ? "dp-day--today" : "",
          isSelected ? "dp-day--selected" : "",
          isWeekend && !isSelected ? "dp-day--weekend" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={() => onSelectDay(dateStr)}
        aria-label={dateStr}
        aria-pressed={isSelected}
      >
        {d}
      </button>,
    );
  }

  return <div className="dp-days">{days}</div>;
};

export default DatePickerDays;
